import { QueryHookOptions, useQuery } from '@apollo/client';

import { GROUPS_BY_UNIT_SLUG_QUERY } from './queries';
import { Group } from './types';

export const useGroupsByUnitSlug = (slug?: string, options?: QueryHookOptions) =>
  useQuery<{ unitBySlug: { canOpenEvaluations: boolean; groups: Group[] } }>(GROUPS_BY_UNIT_SLUG_QUERY, { skip: !slug, variables: { slug }, ...options });
